
const BASE_TIME = "2021-01-01";
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchDeepScene,
  dispatchDeepSceneOld,
  dispatchGetNzmMemoryStackAll,
  dispatchDeepFind,
  dispatchDeepSceneOptions,
  dispatcheepMemreport,
} from "@/store/performance/actions";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { store } from "@/store";
import {
  readDeepScene,
  readGetNzmMemoryStackAll,
  readDeepFind,
  readDeepSceneOld,
  readDeepSceneVedio,
  readDeepSceneOldVedio,
  readDeepSceneOptions,
  readDeepSceneRport,
} from "@/store/performance/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { ElMessage } from "element-plus";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
import { readSimpleScriptList } from "@/store/task/getters";
import { color } from "html2canvas/dist/types/css/types/color";
import { version } from "echarts/core";
@Options({
  components: {
    SideMenu,
  },
})
export default class ProjectOverview extends Vue {
  public localProject = Number(getLocalProject());
  public activeName = "first";
  public formInline = {
    user: "",
    region: "",
  };
  public btnTrue = true;
  public btnFalse = false;
  public DeepSceneOptionsVersion = "";
  public DeepSceneOptionsDevice = "";
  public tableWidth = "48%";
  public rightBtn() {
    this.btnTrue = !this.btnTrue;
    if (this.btnTrue == false) {
      this.tableWidth = "100%";
    } else {
      this.tableWidth = "48%";
    }
  }

  public leftAllTable = [];
  public rightAllTable = [];
  public leftAllTableAudio = [];
  public rightAllTableAudio = [];
  // 场景
  public selected_table_scene = "";
  // 设备
  public selected_table_device = "";
  // 版本
  public selected_table_version = "";
  public inside_obj_scene = "";
  public selected_table_scene_vedio = "";
  public selected_table_device_vedio = "";
  // 版本
  public selected_table_version_vedio = "";
  public inside_obj_scene_vedio = "";
  // 场景
  public selected_table_scene1 = "";
  // 设备
  public selected_table_device1 = "";
  // 版本
  public selected_table_version1 = "";
  public inside_obj_scene1 = "";
  // 场景
  public selected_table_scene1_vedio = "";
  // 设备
  public selected_table_device1_vedio = "";
  // 版本
  public DeepSceneOptionsScene = "";
  public selected_table_version1_vedio = "";
  public inside_obj_scene1_vedio = "";
  public loading = false;
  public objLoading = false;
  public vedioLoading = false;
  public tableRowClassName(row) {
    let colorNum = "";
    if (row.row.is_exists === 1) {
      colorNum = "#606266";
    } else {
      colorNum = "red";
    }
    return { color: colorNum, height: "40px" };
  }
  public tableRowClassName1(row) {
    let colorNum = "";
    if (row.row.is_exists === 1) {
      colorNum = "#606266";
    } else {
      colorNum = "#00b050";
    }
    return { color: colorNum, height: "40px" };
  }
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "K";
      }
      if (Number(item) > 1024) {
        return (Number(item) / 1024).toFixed(1) + "M";
      }
    } else {
      return "";
    }
  }
  public get DeepSceneOptions() {
    const data = [
      {
        id: 1,
        rate: 5,
        value: 100,
        name: "Item 1",
        children: [
          {
            id: 2,
            rate: 4,
            value: 50,
            name: "Item 1.1",
            children: [
              {
                id: 3,
                rate: 3,
                value: 25,
                name: "Item 1.1.1",
                children: [],
              },
              {
                id: 4,
                rate: 3,
                value: 25,
                name: "Item 1.1.2",
                children: [],
              },
            ],
          },
          {
            id: 5,
            rate: 4,
            value: 50,
            name: "Item 1.2",
            children: [
              {
                id: 6,
                rate: 3,
                value: 25,
                name: "Item 1.2.1",
                children: [],
              },
              {
                id: 7,
                rate: 3,
                value: 25,
                name: "Item 1.2.2",
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: 1,
        rate: 5,
        value: 100,
        name: "Item 1",
        children: [
          {
            id: 2,
            rate: 4,
            value: 50,
            name: "Item 1.1",
            children: [
              {
                id: 3,
                rate: 3,
                value: 25,
                name: "Item 1.1.1",
                children: [],
              },
              {
                id: 4,
                rate: 3,
                value: 25,
                name: "Item 1.1.2",
                children: [],
              },
            ],
          },
          {
            id: 5,
            rate: 4,
            value: 50,
            name: "Item 1.2",
            children: [
              {
                id: 6,
                rate: 3,
                value: 25,
                name: "Item 1.2.1",
                children: [],
              },
              {
                id: 3,
                rate: 3,
                value: 25,
                name: "Item 1.2.2",
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: 1,
        rate: 5,
        value: 100,
        name: "Item 1",
        children: [
          {
            id: 2,
            rate: 4,
            value: 50,
            name: "Item 1.1",
            children: [
              {
                id: 3,
                rate: 3,
                value: 25,
                name: "Item 1.1.1",
                children: [],
              },
              {
                id: 4,
                rate: 3,
                value: 25,
                name: "Item 1.1.2",
                children: [],
              },
            ],
          },
          {
            id: 5,
            rate: 4,
            value: 50,
            name: "Item 1.2",
            children: [
              {
                id: 6,
                rate: 3,
                value: 25,
                name: "Item 1.2.1",
                children: [],
              },
              {
                id: 3,
                rate: 3,
                value: 25,
                name: "Item 1.2.2",
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: 8,
        rate: 5,
        value: 100,
        name: "Item 2",
        children: [
          {
            id: 1,
            rate: 4,
            value: 50,
            name: "Item 2.1",
            children: [
              {
                id: 10,
                rate: 3,
                value: 25,
                name: "Item 2.1.1",
                children: [],
              },
              {
                id: 11,
                rate: 3,
                value: 25,
                name: "Item 2.1.2",
                children: [],
              },
            ],
          },
          {
            id: 12,
            rate: 4,
            value: 50,
            name: "Item 2.2",
            children: [
              {
                id: 13,
                rate: 3,
                value: 25,
                name: "Item 2.2.1",
                children: [],
              },
              {
                id: 7,
                rate: 3,
                value: 25,
                name: "Item 2.2.2",
                children: [],
              },
            ],
          },
        ],
      },
    ];
    return readDeepSceneOptions(store);
  }
  public DeepSceneOptions_device() {
    let list = [];
    for (let i in this.DeepSceneOptions.options) {
      if (this.DeepSceneOptionsVersion == i) {
        for (let k in this.DeepSceneOptions.options[i]) {
          list.push(Number(k));
        }
      }
    }

    return list;
  }
  public get getScenes() {
    const scenes = readProjectScenes(store);
    return scenes;
  }
  public get scene_options_change() {
    const scene_list: any[] = this.DeepSceneOptions_scene();
    let list = [];
    if (scene_list?.length > 0) {
      scene_list.forEach((scene) => {
        this.getScenes.forEach((v: any) => {
          if (v?.id === scene) {
            list.push(v);
          }
        });
      });
    }

    return list;
  }
  public columnStyle({ row, column, rowIndex, columnIndex }) {
    if (columnIndex == 1) {
      //第二三第四列的背景色就改变了2和3都是列数的下标

      //字体颜色
      return "padding:0px";
    }
  }
  public get device_options3() {
    const devices = this.DeepSceneOptions_device();
    const device_select: any[] = [];
    devices?.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];

      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }

    return dest.sort(compare("level"));
  }
  public deviationColor(item: any) {
    if (item) {
      if (String(item).indexOf("+") != -1) {
        return "red";
      }
      if (String(item).indexOf("-") != -1) {
        return "#00b050";
      }
    }
  }
  public deviation(item: any) {
    if (item) {
      if (Math.abs(Number(item)) < 1024) {
        return "(" + String(item) + "K)";
      }
      if (Math.abs(Number(item)) > 1024) {
        if (item.indexOf("+") != -1) {
          return "(+" + String((Number(item) / 1024).toFixed(1)) + "M)";
        } else if (String(item).indexOf("-") != -1) {
          return "(" + String((Number(item) / 1024).toFixed(1)) + "M)";
        }
      }
    } else {
      return "";
    }
  }
  public async get_default_params(
    version: boolean,
    device: boolean,
    scene: boolean
  ) {
    // 场景默认值，取列表的第一个
    if (scene) {
      this.selected_table_scene = (readDeepScene(
        store
      ) as any).scene_list[0].scene_id;
      this.selected_table_scene_vedio = (readDeepSceneVedio(
        store
      ) as any).scene_list[0].scene_id;
      if ((readDeepSceneOld(store) as any).scene_list.length >= 2) {
        this.selected_table_scene1 = (readDeepSceneOld(
          store
        ) as any).scene_list[0].scene_id;
        this.selected_table_scene1_vedio = (readDeepSceneOldVedio(
          store
        ) as any).scene_list[0].scene_id;
      } else {
        this.selected_table_scene1 = (readDeepSceneOld(
          store
        ) as any).scene_list[0].scene_id;
        this.selected_table_scene1_vedio = (readDeepSceneOldVedio(
          store
        ) as any).scene_list[0].scene_id;
      }
    }
    if (version) {
      // 版本默认值，取列表的第一个
      this.selected_table_version = (readDeepScene(
        store
      ) as any).game_versions[0].value;
      this.selected_table_version_vedio = (readDeepSceneVedio(
        store
      ) as any).game_versions[0].value;

      this.selected_table_version1 = (readDeepSceneOld(
        store
      ) as any).game_versions[0].value;

      this.selected_table_version1_vedio = (readDeepSceneOldVedio(
        store
      ) as any).game_versions[0].value;
    }
    // 设备默认值，取列表的第一个
    if (device) {
      this.selected_table_device = (readDeepScene(store) as any).device_list[0];
      this.selected_table_device_vedio = (readDeepSceneVedio(
        store
      ) as any).device_list[0];
      if ((readDeepSceneOld(store) as any).device_list.length >= 2) {
        this.selected_table_device1 = (readDeepSceneOld(
          store
        ) as any).device_list[0];
        this.selected_table_device1_vedio = (readDeepSceneOldVedio(
          store
        ) as any).device_list[0];
      } else {
        this.selected_table_device1 = (readDeepSceneOld(
          store
        ) as any).device_list[0];
        this.selected_table_device1_vedio = (readDeepSceneOldVedio(
          store
        ) as any).device_list[0];
      }
    }
  }

  public async get_default_inside_scene() {
    if ((readDeepSceneOld(store) as any).inside_scene_list_old.length >= 2) {
      this.inside_obj_scene1 = (readDeepSceneOld(
        store
      ) as any).inside_scene_list_old[1];
    } else {
      this.inside_obj_scene1 = (readDeepSceneOld(
        store
      ) as any).inside_scene_list_old[0];
    }
  }
  public async get_default_inside_scene_vedio() {
    if (
      (readDeepSceneOldVedio(store) as any).inside_scene_list_old.length >= 2
    ) {
      this.inside_obj_scene1_vedio = (readDeepSceneOldVedio(
        store
      ) as any).inside_scene_list_old[1];
    } else {
      this.inside_obj_scene1_vedio = (readDeepSceneOldVedio(
        store
      ) as any).inside_scene_list_old[0];
    }
  }

  public async mounted() {
    this.loading = true;
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetProjectScenes(store, { project: this.localProject });
    await dispatchDeepSceneOptions(store, { project: this.localProject });
    if (this.DeepSceneOptions.version.length > 0) {
      this.DeepSceneOptionsVersion = this.DeepSceneOptions?.version[0]?.value;
      this.DeepSceneOptionsDevice = (this
        .device_options3 as any)[0]?.data[0].value;
      this.DeepSceneOptionsScene = (this.scene_options_change as any)[0]?.id;
      await dispatcheepMemreport(store, {
        project: this.localProject,
        version: this.DeepSceneOptionsVersion,
        device: this.DeepSceneOptionsDevice,
        scene: this.DeepSceneOptionsScene,
      });
    }

    await dispatchDeepScene(store, {
      project: this.localProject,
      type: "object",
      version: this.selected_table_version,
      scene:
        this.selected_table_scene == ""
          ? ""
          : Number(this.selected_table_scene),
      device:
        this.selected_table_device == ""
          ? ""
          : Number(this.selected_table_device),
      old_version: this.selected_table_version1,
      old_scene:
        this.selected_table_scene1 == ""
          ? ""
          : Number(this.selected_table_scene1),
      old_device:
        this.selected_table_device1 == ""
          ? ""
          : Number(this.selected_table_device1),
    });
    await dispatchDeepSceneOld(store, {
      project: this.localProject,
      type: "object",
      version: this.selected_table_version1,
      scene:
        this.selected_table_scene1 == ""
          ? ""
          : Number(this.selected_table_scene1),
      device:
        this.selected_table_device1 == ""
          ? ""
          : Number(this.selected_table_device1),
      old_version: this.selected_table_version,
      old_scene:
        this.selected_table_scene == ""
          ? ""
          : Number(this.selected_table_scene),
      old_device:
        this.selected_table_device == ""
          ? ""
          : Number(this.selected_table_device),
    });
    await dispatchDeepScene(store, {
      project: this.localProject,
      type: "vedio",
      version: this.selected_table_version_vedio,
      scene:
        this.selected_table_scene_vedio == ""
          ? ""
          : Number(this.selected_table_scene_vedio),
      device:
        this.selected_table_device_vedio == ""
          ? ""
          : Number(this.selected_table_device_vedio),
      old_version: this.selected_table_version1_vedio,
      old_scene:
        this.selected_table_scene1_vedio == ""
          ? ""
          : Number(this.selected_table_scene1_vedio),
      old_device:
        this.selected_table_device1_vedio == ""
          ? ""
          : Number(this.selected_table_device1_vedio),
    });
    await dispatchDeepSceneOld(store, {
      project: this.localProject,
      type: "vedio",
      version: this.selected_table_version1_vedio,
      scene:
        this.selected_table_scene1_vedio == ""
          ? ""
          : Number(this.selected_table_scene1_vedio),
      device:
        this.selected_table_device1_vedio == ""
          ? ""
          : Number(this.selected_table_device1_vedio),
      old_version: this.selected_table_version_vedio,
      old_scene:
        this.selected_table_scene_vedio == ""
          ? ""
          : Number(this.selected_table_scene_vedio),
      old_device:
        this.selected_table_device_vedio == ""
          ? ""
          : Number(this.selected_table_device_vedio),
    });

    await this.scene_options;
    await this.scene_options1;
    await this.get_default_params(true, true, true);
    // 用设备、场景、版本调用接口获取局内场景列表
    await dispatchDeepScene(store, {
      project: this.localProject,
      type: "object",
      version: this.selected_table_version,
      scene:
        this.selected_table_scene == ""
          ? ""
          : Number(this.selected_table_scene),
      device:
        this.selected_table_device == ""
          ? ""
          : Number(this.selected_table_device),
      old_version: this.selected_table_version1,
      old_scene:
        this.selected_table_scene1 == ""
          ? ""
          : Number(this.selected_table_scene1),
      old_device:
        this.selected_table_device1 == ""
          ? ""
          : Number(this.selected_table_device1),
    });
    await dispatchDeepSceneOld(store, {
      project: this.localProject,
      type: "object",
      version: this.selected_table_version1,
      scene:
        this.selected_table_scene1 == ""
          ? ""
          : Number(this.selected_table_scene1),
      device:
        this.selected_table_device1 == ""
          ? ""
          : Number(this.selected_table_device1),
      old_version: this.selected_table_version,
      old_scene:
        this.selected_table_scene == ""
          ? ""
          : Number(this.selected_table_scene),
      old_device:
        this.selected_table_device == ""
          ? ""
          : Number(this.selected_table_device),
    });
    await dispatchDeepScene(store, {
      project: this.localProject,
      type: "vedio",
      version: this.selected_table_version_vedio,
      scene:
        this.selected_table_scene_vedio == ""
          ? ""
          : Number(this.selected_table_scene_vedio),
      device:
        this.selected_table_device_vedio == ""
          ? ""
          : Number(this.selected_table_device_vedio),
      old_version: this.selected_table_version1_vedio,
      old_scene:
        this.selected_table_scene1_vedio == ""
          ? ""
          : Number(this.selected_table_scene1_vedio),
      old_device:
        this.selected_table_device1_vedio == ""
          ? ""
          : Number(this.selected_table_device1_vedio),
    });
    await dispatchDeepSceneOld(store, {
      project: this.localProject,
      type: "vedio",
      version: this.selected_table_version1_vedio,
      scene:
        this.selected_table_scene1_vedio == ""
          ? ""
          : Number(this.selected_table_scene1_vedio),
      device:
        this.selected_table_device1_vedio == ""
          ? ""
          : Number(this.selected_table_device1_vedio),
      old_version: this.selected_table_version_vedio,
      old_scene:
        this.selected_table_scene_vedio == ""
          ? ""
          : Number(this.selected_table_scene_vedio),
      old_device:
        this.selected_table_device_vedio == ""
          ? ""
          : Number(this.selected_table_device_vedio),
    });
    this.inside_obj_scene = (readDeepScene(store) as any).inside_scene_list[0];
    this.inside_obj_scene_vedio = (readDeepSceneVedio(
      store
    ) as any).inside_scene_list[0];
    // 局内场景默认值
    this.get_default_inside_scene();
    this.get_default_inside_scene_vedio();
    // 对象内存数据接口
    let tableList = dispatchGetNzmMemoryStackAll(store, {
      project: this.localProject,
      type: "obj",
      version: this.selected_table_version,
      scene:
        this.selected_table_scene == ""
          ? ""
          : Number(this.selected_table_scene),
      device:
        this.selected_table_device == ""
          ? ""
          : Number(this.selected_table_device),
      inside_scene: this.inside_obj_scene,
      depth: 0,
      name: "",
      old_version: this.selected_table_version1,
      old_scene:
        this.selected_table_scene1 == ""
          ? ""
          : Number(this.selected_table_scene1),
      old_device:
        this.selected_table_device1 == ""
          ? ""
          : Number(this.selected_table_device1),
      old_inside_scene: this.inside_obj_scene1,
    });

    await tableList.then((res) => {
      this.leftAllTable = res.new;
      this.rightAllTable = res.old;
    });
    if (this.leftAllTable.length > 0) {
      this.leftAllTable.forEach((v) => {
        (this.$refs.leftTable as any).toggleRowExpansion(v, true);
      });
    }
    // 音频内存数据接口
    let tableList1 = dispatchGetNzmMemoryStackAll(store, {
      project: this.localProject,
      type: "vedio",
      version: this.selected_table_version_vedio,
      scene:
        this.selected_table_scene_vedio == ""
          ? ""
          : Number(this.selected_table_scene_vedio),
      device:
        this.selected_table_device_vedio == ""
          ? ""
          : Number(this.selected_table_device_vedio),
      inside_scene: this.inside_obj_scene_vedio,
      depth: 0,
      name: "",
      old_version: this.selected_table_version1_vedio,
      old_scene:
        this.selected_table_scene1_vedio == ""
          ? ""
          : Number(this.selected_table_scene1_vedio),
      old_device:
        this.selected_table_device1_vedio == ""
          ? ""
          : Number(this.selected_table_device1_vedio),
      old_inside_scene: this.inside_obj_scene1_vedio,
    });
    await tableList1.then((res) => {
      this.leftAllTableAudio = res.new;
      this.rightAllTableAudio = res.old;
    });
    if (this.leftAllTableAudio.length > 0) {
      this.leftAllTableAudio.forEach((v) => {
        (this.$refs.leftTable1 as any).toggleRowExpansion(v, true);
      });
    }
    this.loading = false;
  }
  public get device_options_vedio() {
    const devices = this.performace_select_options_vedio.device_list;
    const device_select: any[] = [];
    devices?.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest.sort(compare("level"));
  }
  public contrastBtn() {
    this.objLoading = true;
    this.leftAllTable = [];
    this.rightAllTable = [];
    let readList = dispatchGetNzmMemoryStackAll(store, {
      project: this.localProject,
      type: "obj",
      version: this.selected_table_version,
      scene:
        this.selected_table_scene == ""
          ? ""
          : Number(this.selected_table_scene),
      device:
        this.selected_table_device == ""
          ? ""
          : Number(this.selected_table_device),
      inside_scene: this.inside_obj_scene,
      depth: 0,
      name: "",
      old_version: this.selected_table_version1,
      old_scene:
        this.selected_table_scene1 == ""
          ? ""
          : Number(this.selected_table_scene1),
      old_device:
        this.selected_table_device1 == ""
          ? ""
          : Number(this.selected_table_device1),
      old_inside_scene: this.inside_obj_scene1,
    });
    readList.then((res) => {
      this.rightAllTable = res.old;
      this.leftAllTable = res.new;
      this.objLoading = false;
    });
  }
  public contrastBtn1() {
    this.vedioLoading = true;
    this.rightAllTableAudio = [];
    this.leftAllTableAudio = [];
    let readList = dispatchGetNzmMemoryStackAll(store, {
      project: this.localProject,
      type: "vedio",
      version: this.selected_table_version_vedio,
      scene:
        this.selected_table_scene_vedio == ""
          ? ""
          : Number(this.selected_table_scene_vedio),
      device:
        this.selected_table_device_vedio == ""
          ? ""
          : Number(this.selected_table_device_vedio),
      inside_scene: this.inside_obj_scene_vedio,
      depth: 0,
      name: "",
      old_version: this.selected_table_version1_vedio,
      old_scene:
        this.selected_table_scene1_vedio == ""
          ? ""
          : Number(this.selected_table_scene1_vedio),
      old_device:
        this.selected_table_device1_vedio == ""
          ? ""
          : Number(this.selected_table_device1_vedio),
      old_inside_scene: this.inside_obj_scene1_vedio,
    });
    readList.then((res) => {
      this.rightAllTableAudio = res.old;
      this.leftAllTableAudio = res.new;
      this.vedioLoading = false;
    });
  }
  public get device_options() {
    const devices = this.performace_select_options.device_list;
    const device_select: any[] = [];
    devices?.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest.sort(compare("level"));
  }
  public get device_options1() {
    const devices = this.performace_select_options_old.device_list;
    const device_select: any[] = [];
    devices?.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];

      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }

    return dest.sort(compare("level"));
  }
  public thirdChange() {
    this.DeepSceneOptionsScene = (this.scene_options_change as any)[0]?.id;
    dispatcheepMemreport(store, {
      project: this.localProject,
      version: this.DeepSceneOptionsVersion,
      device: this.DeepSceneOptionsDevice,
      scene: this.DeepSceneOptionsScene,
    });
  }
  public DeepSceneOptions_scene() {
    for (let i in this.DeepSceneOptions.options) {
      if (this.DeepSceneOptionsVersion == i) {
        for (let k in this.DeepSceneOptions.options[i]) {
          if (this.DeepSceneOptionsDevice == k) {
            return this.DeepSceneOptions.options[i][k];
          }
        }
      }
    }
  }
  public get device_options1_vedio() {
    const devices = this.performace_select_options_old_vedio.device_list;
    const device_select: any[] = [];
    devices?.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];

      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }

    return dest.sort(compare("level"));
  }

  public get details_list() {
    let list: any = [];
    list = [
      { label: "名称", prop: "name" },
      { label: "类型", prop: "type" },
      { label: "size", prop: "size" },
    ];

    return list;
  }
  public childrenListArray = [];
  public childrenListArray1 = [];
  public childrenListArray2 = [];
  public childrenListArray3 = [];
  public async MemoryChange(type, option, num) {
    let version_option = false;
    let device_option = false;
    let scene_option = false;
    if (option === "version") {
      device_option = true;
      scene_option = true;
    } else if (option === "device") {
      scene_option = true;
    }
    if (type === "obj") {
      await dispatchDeepScene(store, {
        project: this.localProject,
        type: "object",
        version: this.selected_table_version,
        scene:
          this.selected_table_scene == ""
            ? ""
            : Number(this.selected_table_scene),
        device:
          this.selected_table_device == ""
            ? ""
            : Number(this.selected_table_device),
        old_version: this.selected_table_version1,
        old_scene:
          this.selected_table_scene1 == ""
            ? ""
            : Number(this.selected_table_scene1),
        old_device:
          this.selected_table_device1 == ""
            ? ""
            : Number(this.selected_table_device1),
      });

      await this.deep_scene_obj_options;
      await this.deep_scene_obj_old_options;
      await this.deep_scene_obj_options_vedio;
      await this.deep_scene_obj_old_options_vedio;
      await this.get_default_params(
        version_option,
        device_option,
        scene_option
      );
      // 获取局内场景
      await dispatchDeepScene(store, {
        project: this.localProject,
        type: "object",
        version: this.selected_table_version,
        scene:
          this.selected_table_scene == ""
            ? ""
            : Number(this.selected_table_scene),
        device:
          this.selected_table_device == ""
            ? ""
            : Number(this.selected_table_device),
        old_version: this.selected_table_version1,
        old_scene:
          this.selected_table_scene1 == ""
            ? ""
            : Number(this.selected_table_scene1),
        old_device:
          this.selected_table_device1 == ""
            ? ""
            : Number(this.selected_table_device1),
      });
      if (!num) {
        this.inside_obj_scene = readDeepScene(store).inside_scene_list[0];
      }
    }
    if (type == "obj1") {
      await dispatchDeepSceneOld(store, {
        project: this.localProject,
        type: "object",
        version: this.selected_table_version1,
        scene:
          this.selected_table_scene1 == ""
            ? ""
            : Number(this.selected_table_scene1),
        device:
          this.selected_table_device1 == ""
            ? ""
            : Number(this.selected_table_device1),
        old_version: this.selected_table_version,
        old_scene:
          this.selected_table_scene == ""
            ? ""
            : Number(this.selected_table_scene),
        old_device:
          this.selected_table_device == ""
            ? ""
            : Number(this.selected_table_device),
      });
      await this.deep_scene_obj_options;
      await this.deep_scene_obj_old_options;
      await this.deep_scene_obj_options_vedio;
      await this.deep_scene_obj_old_options_vedio;
      await this.get_default_params(
        version_option,
        device_option,
        scene_option
      );
      await dispatchDeepSceneOld(store, {
        project: this.localProject,
        type: "object",
        version: this.selected_table_version1,
        scene:
          this.selected_table_scene1 == ""
            ? ""
            : Number(this.selected_table_scene1),
        device:
          this.selected_table_device1 == ""
            ? ""
            : Number(this.selected_table_device1),
        old_version: this.selected_table_version,
        old_scene:
          this.selected_table_scene == ""
            ? ""
            : Number(this.selected_table_scene),
        old_device:
          this.selected_table_device == ""
            ? ""
            : Number(this.selected_table_device),
      });
      if (!num) {
        this.inside_obj_scene1 = readDeepSceneOld(store).inside_scene_list[0];
      }
    }
    if (type == "vedio1") {
      await dispatchDeepSceneOld(store, {
        project: this.localProject,
        type: "vedio",
        version: this.selected_table_version1_vedio,
        scene:
          this.selected_table_scene1_vedio == ""
            ? ""
            : Number(this.selected_table_scene1_vedio),
        device:
          this.selected_table_device1_vedio == ""
            ? ""
            : Number(this.selected_table_device1_vedio),
        old_version: this.selected_table_version_vedio,
        old_scene:
          this.selected_table_scene_vedio == ""
            ? ""
            : Number(this.selected_table_scene_vedio),
        old_device:
          this.selected_table_device_vedio == ""
            ? ""
            : Number(this.selected_table_device_vedio),
      });
      await this.deep_scene_obj_options;
      await this.deep_scene_obj_old_options;
      await this.deep_scene_obj_options_vedio;
      await this.deep_scene_obj_old_options_vedio;
      await this.get_default_params(
        version_option,
        device_option,
        scene_option
      );
      await dispatchDeepSceneOld(store, {
        project: this.localProject,
        type: "vedio",
        version: this.selected_table_version1_vedio,
        scene:
          this.selected_table_scene1_vedio == ""
            ? ""
            : Number(this.selected_table_scene1_vedio),
        device:
          this.selected_table_device1_vedio == ""
            ? ""
            : Number(this.selected_table_device1_vedio),
        old_version: this.selected_table_version_vedio,
        old_scene:
          this.selected_table_scene_vedio == ""
            ? ""
            : Number(this.selected_table_scene_vedio),
        old_device:
          this.selected_table_device_vedio == ""
            ? ""
            : Number(this.selected_table_device_vedio),
      });
      if (!num) {
        this.inside_obj_scene1_vedio = readDeepSceneOldVedio(
          store
        ).inside_scene_list[0];
      }
    }
    if (type == "vedio") {
      await dispatchDeepScene(store, {
        project: this.localProject,
        type: "vedio",
        version: this.selected_table_version_vedio,
        scene:
          this.selected_table_scene_vedio == ""
            ? ""
            : Number(this.selected_table_scene_vedio),
        device:
          this.selected_table_device_vedio == ""
            ? ""
            : Number(this.selected_table_device_vedio),
        old_version: this.selected_table_version1_vedio,
        old_scene:
          this.selected_table_scene1_vedio == ""
            ? ""
            : Number(this.selected_table_scene1_vedio),
        old_device:
          this.selected_table_device1_vedio == ""
            ? ""
            : Number(this.selected_table_device1_vedio),
      });
      await this.deep_scene_obj_options;
      await this.deep_scene_obj_old_options;
      await this.deep_scene_obj_options_vedio;
      await this.deep_scene_obj_old_options_vedio;
      await this.get_default_params(
        version_option,
        device_option,
        scene_option
      );
      await dispatchDeepScene(store, {
        project: this.localProject,
        type: "vedio",
        version: this.selected_table_version_vedio,
        scene:
          this.selected_table_scene_vedio == ""
            ? ""
            : Number(this.selected_table_scene_vedio),
        device:
          this.selected_table_device_vedio == ""
            ? ""
            : Number(this.selected_table_device_vedio),
        old_version: this.selected_table_version1_vedio,
        old_scene:
          this.selected_table_scene1_vedio == ""
            ? ""
            : Number(this.selected_table_scene1_vedio),
        old_device:
          this.selected_table_device1_vedio == ""
            ? ""
            : Number(this.selected_table_device1_vedio),
      });
      if (!num) {
        this.inside_obj_scene_vedio = readDeepSceneVedio(
          store
        ).inside_scene_list[0];
      }
    }
  }
  public expandRowKeys = [];
  public num = -1;
  public changeList = [];
  public changeList1 = [];
  public num1 = -1;
  public inputColor = "";
  public inputColor1 = "";
  public async submit() {
    this.num += 1;
    await dispatchDeepFind(store, {
      project: this.localProject,
      type: "obj",
      version: this.selected_table_version,
      scene:
        this.selected_table_scene == ""
          ? ""
          : Number(this.selected_table_scene),
      device:
        this.selected_table_device == ""
          ? ""
          : Number(this.selected_table_device),
      inside_scene: this.inside_obj_scene,
      old_version: this.selected_table_version1,
      old_scene:
        this.selected_table_scene1 == ""
          ? ""
          : Number(this.selected_table_scene1),
      old_device:
        this.selected_table_device1 == ""
          ? ""
          : Number(this.selected_table_device1),
      old_inside_scene: this.inside_obj_scene1,
      name: this.inputValue,
    });
    if (readDeepFind(store).length != 0) {
      this.inputColor = "inputYellow";
    } else {
      this.inputColor = "inputWhite";
    }

    this.changeList.push(readDeepFind(store));
    if (this.num == 0) {
      this.changeList[0]?.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });
      if (this.changeList[0].length != 0) {
        this.$nextTick(() => {
          if (document.getElementById(this.changeList[0][0]?.id) != null) {
            document.getElementById(
              this.changeList[0][0]?.id
            ).style.backgroundColor = "yellow";
            document.getElementById(this.changeList[0][0]?.id).scrollIntoView();
          }
          if (document.getElementById(this.changeList[0][0]?.id + 1) != null) {
            document.getElementById(
              this.changeList[0][0]?.id + 1
            ).style.backgroundColor = "yellow";

            document
              .getElementById(this.changeList[0][0]?.id + 1)
              .scrollIntoView();
          }
        });
      }
    } else {
      this.changeList[this.num - 1]?.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, false);
      });
      this.changeList[this.num]?.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });

      if (this.changeList[this.num]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList[this.num][0].id) != null
          ) {
            document.getElementById(
              this.changeList[this.num][0].id
            ).style.backgroundColor = "yellow";
            document
              .getElementById(this.changeList[this.num][0].id)
              .scrollIntoView();
          }
          if (
            document.getElementById(this.changeList[this.num][0].id + 1) != null
          ) {
            document.getElementById(
              this.changeList[this.num][0].id + 1
            ).style.backgroundColor = "yellow";
            document
              .getElementById(this.changeList[this.num][0].id + 1)
              .scrollIntoView();
          }
        });
      }
      if (this.changeList[this.num - 1]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList[this.num - 1][0].id) != null
          ) {
            document.getElementById(
              this.changeList[this.num - 1][0].id
            ).style.backgroundColor = "#fff";
          }
          if (
            document.getElementById(this.changeList[this.num - 1][0].id + 1) !=
            null
          ) {
            document.getElementById(
              this.changeList[this.num - 1][0].id + 1
            ).style.backgroundColor = "#fff";
          }
        });
      }
    }
  }
  public get deepSceneRport() {
    readDeepSceneRport(store).forEach((v) => {
      v.time = dateConversion(v.time);
    });
    return readDeepSceneRport(store);
  }
  // public async tabsChange(){
  //   if(this.activeName==='second'){
  //   await dispatchDeepScene(store, {
  //     project: this.localProject,
  //     type: "vedio",
  //     version: this.selected_table_version_vedio,
  //     scene:
  //       this.selected_table_scene_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene_vedio),
  //     device:
  //       this.selected_table_device_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device_vedio),
  //     old_version: this.selected_table_version1_vedio,
  //     old_scene:
  //       this.selected_table_scene1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene1_vedio),
  //     old_device:
  //       this.selected_table_device1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device1_vedio),
  //   });
  //   await dispatchDeepSceneOld(store, {
  //     project: this.localProject,
  //     type: "vedio",
  //     version: this.selected_table_version1_vedio,
  //     scene:
  //       this.selected_table_scene1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene1_vedio),
  //     device:
  //       this.selected_table_device1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device1_vedio),
  //     old_version: this.selected_table_version_vedio,
  //     old_scene:
  //       this.selected_table_scene_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene_vedio),
  //     old_device:
  //       this.selected_table_device_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device_vedio),
  //   });

  //   await this.scene_options;
  //   await this.scene_options1;
  //   await this.get_default_params(true, true, true);
  //   // 用设备、场景、版本调用接口获取局内场景列表
  //   await dispatchDeepScene(store, {
  //     project: this.localProject,
  //     type: "vedio",
  //    version: this.selected_table_version_vedio,
  //     scene:
  //       this.selected_table_scene_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene_vedio),
  //     device:
  //       this.selected_table_device_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device_vedio),
  //     old_version: this.selected_table_version1_vedio,
  //     old_scene:
  //       this.selected_table_scene1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene1_vedio),
  //     old_device:
  //       this.selected_table_device1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device1_vedio),
  //   });
  //   await dispatchDeepSceneOld(store, {
  //     project: this.localProject,
  //     type: "vedio",
  //       version: this.selected_table_version1_vedio,
  //     scene:
  //       this.selected_table_scene1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene1_vedio),
  //     device:
  //       this.selected_table_device1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device1_vedio),
  //     old_version: this.selected_table_version_vedio,
  //     old_scene:
  //       this.selected_table_scene_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene_vedio),
  //     old_device:
  //       this.selected_table_device_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device_vedio),
  //   });
  //     await this.deep_scene_obj_options;
  //     await this.deep_scene_obj_old_options;
  //   this.inside_obj_scene_vedio = (readDeepScene(
  //     store
  //   ) as any).inside_scene_list[0];
  //   // 局内场景默认值
  //   this.get_default_inside_scene1();
  //   // 对象内存数据接口
  //   let tableList1 = dispatchGetNzmMemoryStackAll(store, {
  //     project: this.localProject,
  //     type: "vedio",
  //     version: this.selected_table_version_vedio,
  //     scene:
  //       this.selected_table_scene_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene_vedio),
  //     device:
  //       this.selected_table_device_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device_vedio),
  //     inside_scene: this.inside_obj_scene_vedio,
  //     depth: 0,
  //     name: "",
  //     old_version: this.selected_table_version1_vedio,
  //     old_scene:
  //       this.selected_table_scene1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_scene1_vedio),
  //     old_device:
  //       this.selected_table_device1_vedio == ""
  //         ? ""
  //         : Number(this.selected_table_device1_vedio),
  //     old_inside_scene: this.inside_obj_scene1_vedio,
  //   });
  //   await tableList1.then((res) => {
  //     this.leftAllTableAudio = res.new;
  //     this.rightAllTableAudio = res.old;
  //   });
  //   if (this.leftAllTableAudio.length > 0) {
  //     this.leftAllTableAudio.forEach((v) => {
  //       (this.$refs.leftTable1 as any).toggleRowExpansion(v, true);
  //     });
  //   }
  //   }
  // }
  public async submit1() {
    this.num1 += 1;
    await dispatchDeepFind(store, {
      project: this.localProject,
      type: "vedio",
      version: this.selected_table_version_vedio,
      scene:
        this.selected_table_scene_vedio == ""
          ? ""
          : Number(this.selected_table_scene_vedio),
      device:
        this.selected_table_device_vedio == ""
          ? ""
          : Number(this.selected_table_device_vedio),
      inside_scene: this.inside_obj_scene_vedio,
      old_version: this.selected_table_version1_vedio,
      old_scene:
        this.selected_table_scene1_vedio == ""
          ? ""
          : Number(this.selected_table_scene1_vedio),
      old_device:
        this.selected_table_device1_vedio == ""
          ? ""
          : Number(this.selected_table_device1_vedio),
      old_inside_scene: this.inside_obj_scene1_vedio,
      name: this.inputValue1,
    });
    if (readDeepFind(store).length != 0) {
      this.inputColor1 = "inputYellow1";
    } else {
      this.inputColor1 = "inputWhite1";
    }
    this.changeList1.push(readDeepFind(store));
    if (this.num1 == 0) {
      this.changeList1[0]?.forEach((v) => {
        (this.$refs.table1 as any).toggleRowExpansion(v, true);
      });
      if (this.changeList1[0].length != 0) {
        this.$nextTick(() => {
          if (document.getElementById(this.changeList1[0][0]?.id) != null) {
            document.getElementById(
              this.changeList1[0][0]?.id
            ).style.backgroundColor = "yellow";
            document
              .getElementById(this.changeList1[0][0]?.id)
              .scrollIntoView();
          }
          if (document.getElementById(this.changeList1[0][0]?.id + 1) != null) {
            document.getElementById(
              this.changeList1[0][0]?.id + 1
            ).style.backgroundColor = "yellow";

            document
              .getElementById(this.changeList1[0][0]?.id + 1)
              .scrollIntoView();
          }
        });
      }
    } else {
      this.changeList1[this.num1 - 1]?.forEach((v) => {
        (this.$refs.table1 as any).toggleRowExpansion(v, false);
      });
      this.changeList1[this.num1]?.forEach((v) => {
        (this.$refs.table1 as any).toggleRowExpansion(v, true);
      });

      if (this.changeList1[this.num1]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList1[this.num1][0].id) != null
          ) {
            document.getElementById(
              this.changeList1[this.num1][0].id
            ).style.backgroundColor = "yellow";
            document
              .getElementById(this.changeList1[this.num1][0].id)
              .scrollIntoView();
          }
          if (
            document.getElementById(this.changeList1[this.num1][0].id + 1) !=
            null
          ) {
            document.getElementById(
              this.changeList1[this.num1][0].id + 1
            ).style.backgroundColor = "yellow";
            document
              .getElementById(this.changeList1[this.num1][0].id + 1)
              .scrollIntoView();
          }
        });
      }
      if (this.changeList1[this.num1 - 1]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList1[this.num1 - 1][0].id) !=
            null
          ) {
            document.getElementById(
              this.changeList1[this.num1 - 1][0].id
            ).style.backgroundColor = "#fff";
          }

          if (
            document.getElementById(
              this.changeList1[this.num1 - 1][0].id + 1
            ) != null
          ) {
            document.getElementById(
              this.changeList1[this.num1 - 1][0].id + 1
            ).style.backgroundColor = "#fff";
          }
        });
      }
    }
  }
  public versionChange() {
    this.DeepSceneOptionsDevice = (this
      .device_options3 as any)[0]?.data[0].value;
    this.DeepSceneOptionsScene = (this.scene_options_change as any)[0]?.id;
    // this.scene_options_change

    dispatcheepMemreport(store, {
      project: this.localProject,
      version: this.DeepSceneOptionsVersion,
      device: this.DeepSceneOptionsDevice,
      scene: this.DeepSceneOptionsScene,
    });
  }
  public get performace_select_options() {
    const options = readDeepScene(store);

    return options;
  }
  public get performace_select_options_vedio() {
    const options = readDeepSceneVedio(store);

    return options;
  }
  public get performace_select_options_old() {
    const options = readDeepSceneOld(store);
    return options;
  }
  public get performace_select_options_old_vedio() {
    const options = readDeepSceneOldVedio(store);
    return options;
  }
  public get deep_scene_obj_options() {
    const scenes = readDeepScene(store).inside_scene_list;
    return scenes;
  }
  public get deep_scene_obj_old_options() {
    const scenes = readDeepSceneOld(store).inside_scene_list;
    return scenes;
  }
  public get deep_scene_obj_options_vedio() {
    const scenes = readDeepSceneVedio(store).inside_scene_list;
    return scenes;
  }
  public get deep_scene_obj_old_options_vedio() {
    const scenes = readDeepSceneOldVedio(store).inside_scene_list;
    return scenes;
  }

  public get scene_options() {
    const scene_list: any[] = this.performace_select_options.scene_list;
    return scene_list?.sort(compare("count"));
  }
  public get scene_options_vedio() {
    const scene_list: any[] = this.performace_select_options_vedio.scene_list;
    return scene_list?.sort(compare("count"));
  }
  public get scene_options1() {
    const scene_list: any[] = this.performace_select_options_old.scene_list;
    return scene_list?.sort(compare("count"));
  }
  public get scene_options1_vedio() {
    const scene_list: any[] = this.performace_select_options_old_vedio
      .scene_list;
    return scene_list?.sort(compare("count"));
  }
  public get all_device_options() {
    const devices = this.performace_select_options.device_list;
    const device_select: any[] = [];
    devices?.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
      });
    });
    return device_select;
  }

  public get getDeviceSpecs() {
    return readDeviceSpecs(store);
  }
  public get game_version_options() {
    return this.performace_select_options.game_versions;
  }
  public get game_version_options_vedio() {
    return this.performace_select_options_vedio.game_versions;
  }
  public expandChangeId: number | string;
  public expandChangeRows = true;
  public b = false;
  public handleExpandChange(row, rows) {
    if (rows === false) {
      (this.$refs.table as any).toggleRowExpansion(row, false);
    }
    if (rows === true) {
      (this.$refs.table as any).toggleRowExpansion(row, true);
    }
  }
  public fourthChange() {
    dispatcheepMemreport(store, {
      project: this.localProject,
      version: this.DeepSceneOptionsVersion,
      device: this.DeepSceneOptionsDevice,
      scene: this.DeepSceneOptionsScene,
    });
  }
  public handleExpandChange1(row, rows) {
    if (rows === false) {
      (this.$refs.leftTable as any).toggleRowExpansion(row, false);
    }
    if (rows === true) {
      (this.$refs.leftTable as any).toggleRowExpansion(row, true);
    }
  }
  public handleExpandChange2(row, rows) {
    if (rows === false) {
      (this.$refs.table1 as any).toggleRowExpansion(row, false);
    }
    if (rows === true) {
      (this.$refs.table1 as any).toggleRowExpansion(row, true);
    }
  }
  public handleExpandChange3(row, rows) {
    if (rows === false) {
      (this.$refs.leftTable1 as any).toggleRowExpansion(row, false);
    }
    if (rows === true) {
      (this.$refs.leftTable1 as any).toggleRowExpansion(row, true);
    }
  }

  public get tableList() {
    let list: any = [];
    list = [
      {
        name: "/script/CoreUObject.Object",
        type: "Class",
        Size: "110M",
        is_expand: true,
      },
    ];
    return list;
  }
  public inputValue = "";
  public inputValue1 = "";
  public get tableAllList() {
    return readGetNzmMemoryStackAll(store);
  }
}
